export default __webpack_public_path__ + "static/media/O_wdt_c_cap_1.f473bab4.mp3";